angular.module('impactx.product').controller('ChangeCatalogCtrl', ['$scope', '$mdDialog', 'themeFactory', 'dataGen', '$routeParams',
    'data', 'trns', ChangeCatalogCtrl]);

function ChangeCatalogCtrl($scope, $mdDialog, themeFactory, dataGen, $routeParams, data, trns) {
    $scope.theme = themeFactory.getTheme();
    $scope.trns = trns;
    $scope.data = data;

    this.clearProductGroup = function () {
        $scope.data.changedProductGroup = {};
    };

    this.cancel = function () {
        $mdDialog.cancel();
    };
    this.answer = function () {
        if (impactX.isDefined($scope, 'data.changedProductGroup.id') > 0) {
            var dataObj = {
                pro: $scope.data
            };
            var tempScope = {};
            dataGen.postAsForm(tempScope, dataObj, "/product/changecatalog").then(function () {
                dataGen.getData($scope, {
                    id: $routeParams.id,
                    catId: $routeParams.catId,
                    changewithoutcheckout: !!$routeParams.changewithoutcheckout
                }, "/product/checkout/get").then(function () {
                    $mdDialog.hide($scope.data);
                })
            });
        }
        else {
            $mdDialog.hide($scope.data);
        }
    };
}